var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.title),expression:"title"}],staticClass:"form-table-h380"},[_c('list-view',{ref:"recordOtherTemplatelist",attrs:{"columns":_vm.columnList,"datalist":_vm.datalist,"showSequence":true},on:{"extrabutton-click":_vm.ExtraButtonClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec50285","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anesthsia/RecordOtherTemplate.vue
// module id = null
// module chunks = 